<script>
  export let userId;
  export let name;
  export let email;
</script>

<p>UserID: {userId}</p>
<p>Name: {name}</p>
<p>Email: {email}</p>